export default __webpack_public_path__ + "static/Caesar-c866ae323e9aa67ffaaded7974d5ef25.png";